import React, { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import { List } from "@phosphor-icons/react";

export default function AppLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Lock body scroll when mobile navigation drawer is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <div className="min-h-screen flex bg-[#F5F7F9] text-[#173042] overflow-x-hidden">
      {/* Sidebar navigation */}
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

      {/* Main Content Area */}
      <div className="flex-1 min-w-0 flex flex-col min-h-screen">
        {/* Mobile Header Bar */}
        <header className="lg:hidden bg-[#173B4D] text-white px-4 h-16 flex items-center justify-between sticky top-0 z-30 shadow-xs border-b border-[#24566D]/40">
          <div className="bg-white rounded-lg px-2.5 py-1 shadow-2xs flex items-center gap-2">
            <img src="/nusacert-logo.png" alt="Nusacert" className="h-6 w-auto object-contain" />
            <span className="text-[9px] font-extrabold uppercase tracking-wider bg-[#173B4D] text-white px-1.5 py-0.5 rounded">
              CRM
            </span>
          </div>
          <button
            onClick={() => setMobileOpen(true)}
            className="p-2 -mr-1 rounded-lg hover:bg-white/10 text-white transition-colors"
            aria-label="Open Navigation Menu"
            data-testid="mobile-menu-btn"
          >
            <List size={24} weight="bold" />
          </button>
        </header>

        {/* Page Content Container */}
        <main className="flex-1 min-w-0 page-enter">
          <div className="max-w-[1440px] mx-auto px-3.5 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
